import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-register_company",
  "use": "icon-register_company-usage",
  "viewBox": "0 0 60 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60 48\" id=\"icon-register_company\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-2-8h64v64H-2z\" /><path d=\"M54 42.667h5.333V48H.667v-5.333H6v-40A2.667 2.667 0 0 1 8.667 0h26.666A2.667 2.667 0 0 1 38 2.667v40h10.667V21.333h-5.334V16h8A2.667 2.667 0 0 1 54 18.667v24ZM11.333 5.333v37.334h21.334V5.333H11.333Zm5.334 16h10.666v5.334H16.667v-5.334Zm0-10.666h10.666V16H16.667v-5.333Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol